import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78133281&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=78133281&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78133281",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78133281')) {
      api.createRecord('78133281', component.options)
    } else {
      api.reload('78133281', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=78133281&scoped=true", function () {
      api.rerender('78133281', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/menuStoreTemplateManage/index.vue"
export default component.exports